<section id="index-pricing-section">
    <div class="container">
        <div class="pricing-header text-end text-white">
            <div class="pricing-pill">
                <span class="dot"></span>
                <span>Plans engineered for momentum</span>
            </div>
            <h2>Choose the launch cadence that fits your business.</h2>
            <p class="text-primary">All plans include access to PI | Portal, SSL, observability wiring, and white-glove onboarding.</p>
        </div>

        <div class="row g-4">
            <div class="col-md-4">
                <div class="pricing-card">
                    <div class="card-head">
                        <h5>PI | Static Pack</h5>
                        <p class="text-secondary">Perfect for marketing sites and portfolios that rarely change.</p>
                    </div>
                    <h3 class="price-title"><span class="currency">$</span>1,200 <small>/ launch</small></h3>
                    <ul class="pricing-features">
                        <li>Custom Website</li>
                        <li>Domain Name Setup and DNS Record Management</li>
                        <li>Server setup and hosting</li>
                        <li>Quarterly refresh window</li>
                        <li>Request features via formal SOWs</li>
                        <li>Code turnover after full payment</li>
                    </ul>
                    <button class="btn btn-outline-light w-100">Get Started</button>
                </div>
            </div>
            <div class="col-md-4">
                <div class="pricing-card pricing-card-featured">
                    <div class="card-head">
                        <div class="services-pill">
                            <span class="dot"></span>
                            <span>Most Popular</span>
                        </div>
                        <h5>PI | Dynamic Pack</h5>
                        <p>For growing teams shipping updates weekly and scaling acquisition.</p>
                    </div>
                    <h3 class="price-title"><span class="currency">$</span>2,900 <small>/ month</small></h3>
                    <ul class="pricing-features">
                        <li>Full-stack web app or marketing ecosystem</li>
                        <li>Database setup and RAID management</li>
                        <li>SEO and application use analytics </li>
                        <li>CI/CD pipelines with rollback guardrails</li>
                        <li>Request features via a ticketing system</li>
                    </ul>
                    <button class="btn btn-primary w-100">Get Started</button>
                </div>
            </div>
            <div class="col-md-4">
                <div class="pricing-card">
                    <div class="card-head">
                        <h5>PI | Enterprise Pack</h5>
                        <p class="text-secondary">Customized pods for compliance-heavy programs and multiple brands.</p>
                    </div>
                    <h3 class="price-title">Custom <small>/ annual partnership</small></h3>
                    <ul class="pricing-features">
                        <li>Dedicated product, design, and SRE leads</li>
                        <li>Multi-region infrastructure ownership</li>
                        <li>24/7 on-call with executive reporting</li>
                        <li>Roadmap co-planning and OKR alignment</li>
                        <li>Custom integrations + private training</li>
                    </ul>
                    <button class="btn btn-outline-light w-100">Contact PI | Enterpise</button>
                </div>
            </div>
        </div>
    </div>
</section>
